import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild,
  input,
  output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule],
  selector: 'app-blocking-error-state',
  styleUrl: './blocking-error-state.scss',
  templateUrl: './blocking-error-state.html',
})
export class BlockingErrorState implements AfterViewInit {
  @ViewChild('primaryActionButton', { read: ElementRef })
  private primaryActionButton?: ElementRef<HTMLButtonElement>;

  readonly title = input.required<string>();
  readonly message = input.required<string>();
  readonly primaryActionLabel = input<string>();
  readonly primaryActionDisabled = input(false);
  readonly secondaryActionLabel = input<string>();
  readonly primaryAction = output<void>();
  readonly secondaryAction = output<void>();

  ngAfterViewInit(): void {
    queueMicrotask(() => this.primaryActionButton?.nativeElement.focus());
  }
}
